import classNames from "classnames";
import { store } from "shared/store/store";
import { useSnapshot } from "valtio";

// TODO: MOVE SVG IN THE FUTURE
export default function ArrowPrevious(props: any) {
  const { className, style, onClick } = props;
  const snap = useSnapshot(store);
  return (
    <svg
      style={{ ...style }}
      className={classNames(
        "gg-cursor-pointer gg-fill-dark-blue-900 gg-transition-all gg-duration-1000 gg-ease-in-out hover:gg-fill-dark-blue-500",
        className,
        {
          "gg-opacity-0": snap.active === true,
          "gg-opacity-100": snap.active === false,
        },
      )}
      role="button"
      aria-label="Previous"
      tabIndex={0}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      height="800px"
      width="800px"
      viewBox="0 0 330 330"
    >
      <path
        id="XMLID_6_"
        d="M165,0C74.019,0,0,74.019,0,165s74.019,165,165,165s165-74.019,165-165S255.981,0,165,0z M205.606,234.394  c5.858,5.857,5.858,15.355,0,21.213C202.678,258.535,198.839,260,195,260s-7.678-1.464-10.606-4.394l-80-79.998  c-2.813-2.813-4.394-6.628-4.394-10.606c0-3.978,1.58-7.794,4.394-10.607l80-80.002c5.857-5.858,15.355-5.858,21.213,0  c5.858,5.857,5.858,15.355,0,21.213l-69.393,69.396L205.606,234.394z"
      />
    </svg>
  );
}
